var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "266px",
    height: "129px",
    viewBox: "0 0 266 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tv-top") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---photos",
    transform: "translate(-349.000000, -4814.000000)",
    fill: "#0A303A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(251.000000, 4814.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tv-bg",
    transform: "translate(0.001844, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.423738,31.5123298 C82.9981561,22 122.191485,-0.831595769 133.358054,0.0555519033 C148.781511,1.27258121 158.590887,10.8644958 154.333998,32.461261 C152.113003,43.7650009 163.526373,58.6579924 171.834308,69.5287198 C184.275943,85.8448441 199.781527,99.727649 213.23079,115.301315 C222.79326,126.378516 244.303553,126.254421 254.524614,114.785608 C271.037827,96.2827701 288.682384,78.7494581 304.558064,59.7296457 L304.59918,59.750293 C308.650384,53.9537335 309.822582,46.6104742 307.807272,39.8243226 C302.090532,26.9321659 306.820175,20.7849718 318.438965,15.6902095 C339.908195,6.30492638 357.264783,8.40873372 362.302927,22.3116051 C367.526329,36.7303951 359.053719,44.4036944 346.139278,48.9830662 C310.953348,61.4422103 275.998156,118 281.998156,123 C286.408629,126.675394 299.998156,128 300.425049,128.210899 C254.998156,128 201.998156,128.073501 172.254101,128.210899 C171.875497,128.212647 188.955687,124.710879 194.998156,124 C211.998156,122 145.034698,49.5424047 104.423738,31.5123298 Z",
    id: "tv-top"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvTop);
export default __webpack_public_path__ + "static/media/tv-top.18280213fa17d398db21deac0b729de3.svg";
export { ForwardRef as ReactComponent };